module.exports = __webpack_public_path__ + "static_pc/img/wx5.530342e4.png";